import React from "react";
import { motion } from "framer-motion";
import NavbarComponent from "../component/NavbarComponent";

const MandatoryDisclosure = () => {
  return (
    <React.Fragment>
      <NavbarComponent />

      <div className="min-h-screen text-lg font-bold p-3  mt-4  lg:pl-20 md:pl-20  lg:pr-20 md:pr-20">
        <div className="grid lg:grid-cols-7 gap-4 sm:grid-cols-5  md:grid-cols-5 grid-cols-3 pt-5">
          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Affiliation-Grant-Letter.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Affiliation Grant Letter</h1>
            </div>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Coy Certificate.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Coy Certificate</h1>
            </div>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Reconition-2023.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Reconition 2023</h1>
            </div>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/RTE 2009 Certificate 2023.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">RTE 2009 Certificate 2023</h1>
            </div>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Building-Safety-2023.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Building Safety 2023</h1>
            </div>
          </motion.div>
          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Fire-Safety-2023.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Fire Safety 2023</h1>
            </div>
          </motion.div>
          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Self Certficate 2023.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Self Certficate 2023</h1>
            </div>
          </motion.div>
          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Safe-Drinking-Water-Cert..pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Safe Drinking Water Cert</h1>
            </div>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Fee Structure 2023-24.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Fee Structure 2023-24</h1>
            </div>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Academic Cal 2023-24.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Academic Cal 2023-24</h1>
            </div>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/SMC 2023.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">SMC 2023</h1>
            </div>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/PTA 2023-24.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">PTA 2023-24</h1>
            </div>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Last 3 Yr Result Brief 2023.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Last 3 Yr Result Brief 2023</h1>
            </div>
          </motion.div>
          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Land Certificate 2023"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Land Certificate 2023</h1>
            </div>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/Appendix IX 2023.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">Appendix IX 2023</h1>
            </div>
          </motion.div>
          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex justify-center p-2  cursor-pointer text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600"
          >
            <div className="flex flex-col justify-center">
              <div className="flex justify-center">
                <a
                  href="../assets/SLC Sample.pdf"
                  target="blank"
                  className="text-black font-semibold"
                >
                  <img
                    src="../assets/pdf.png"
                    className="h-20 w-20"
                    alt="pdf"
                  />
                </a>
              </div>
              <h1 className="text-sm p-1">SLC Sample</h1>
            </div>
          </motion.div>


      
        </div>
      </div>

      <footer className="border-t-2">
        <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span className="text-black text-lg font-bold hover:text-blue-300 ">
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default MandatoryDisclosure;
